import { render, staticRenderFns } from "./WorkflowQueryGuidelines.vue?vue&type=template&id=c49a1eb0"
import script from "./WorkflowQueryGuidelines.vue?vue&type=script&lang=js"
export * from "./WorkflowQueryGuidelines.vue?vue&type=script&lang=js"
import style0 from "./mqSharedStyles.css?vue&type=style&index=0&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/CFDE Knowledge - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c49a1eb0')) {
      api.createRecord('c49a1eb0', component.options)
    } else {
      api.reload('c49a1eb0', component.options)
    }
    module.hot.accept("./WorkflowQueryGuidelines.vue?vue&type=template&id=c49a1eb0", function () {
      api.rerender('c49a1eb0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/revealMultiQueryWorkflow/WorkflowQueryGuidelines.vue"
export default component.exports